import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import FormattedMessage from 'I18n/components/FormattedHTMLMessage';
import { EmptyStateContainer } from './EmptyStateContainer';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CustomObjectEmptyState = ({
  pageType
}) => {
  const subTextLangString = pageType === 'board' ? 'emptyStatesNew.customObjects.subTextBoard' : 'emptyStatesNew.customObjects.subTextTable';
  return /*#__PURE__*/_jsx(EmptyStateContainer, {
    children: /*#__PURE__*/_jsx(EmptyState, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "emptyStatesNew.customObjects.titleText"
      }),
      secondaryContent: /*#__PURE__*/_jsx(Illustration, {
        name: "custom-objects"
      }),
      primaryContent: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: subTextLangString
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "emptyStatesNew.customObjects.documentationLink_jsx",
            elements: {
              UILink: Link
            },
            options: {
              href: 'https://developers.hubspot.com/docs/api/crm/crm-custom-objects'
            }
          })
        })]
      })
    })
  });
};